import { render, staticRenderFns } from "./StepResidentRoI.vue?vue&type=template&id=5f93fd0e&"
import script from "./StepResidentRoI.vue?vue&type=script&lang=js&"
export * from "./StepResidentRoI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports